import styled from '@emotion/styled'
import { css } from '@emotion/react'

import theme, { WithTheme } from '../../../setup/index'
import { transition } from '../../../common/Mixins'
import media from '../../../common/MediaQueries'
import { DepositTableProps } from './types'

const DepositTableContainerStyled = styled.div`
  width: 100%;
`

const DepositTableStyled = styled.div`
  width: 100%;
`

const DepositTableRowBodyStyled = styled.div`
  display: none;
  width: 100%;
`

const DepositTableColumnStyled = styled.div`
  flex: 2;
  padding: 1.125rem 1rem;
  font-size: 0.75rem;

  @media ${media.maxPhone} {
    display: none;
  }

  @media ${media.phone} {
    font-size: 0.875rem;
    padding: 1rem;
    ${({ theme }) => (theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;')}

    &:last-of-type {
      max-width: 12.5rem;
      padding-left: 3.125rem;
    }

    &:nth-of-type(2) {
      ${({ theme }) => (theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;')}
    }
  }
`

const DepositTableHeadStyled = styled.div<WithTheme>`
  display: flex;
  color: ${({ theme }) => theme.colors.green};

  ${DepositTableColumnStyled} {
    text-transform: capitalize;
    font-weight: 500;
  }

  @media ${media.maxPhone} {
    display: none;
  }
`

const DepositTableIconStyled = styled.div<WithTheme>`
  display: flex;
  justify-content: center;

  padding: 1.125rem 0.625rem;
  width: 1.875rem;
  color: ${({ theme }) => theme.colors.green};
  svg {
    ${transition}
    width: 0.625rem;
    font-size: 0.625rem;
    margin-top: 0.25rem;
  }
  @media ${media.maxPhone} {
    align-items: center;
    margin-left: 0.625rem;
  }
  @media ${media.phone} {
    width: 0;
    display: none;
  }
`

const DepositTableRowHeadStyled = styled.div<WithTheme<DepositTableProps>>`
  ${transition}
  display: flex;
  width: 100%;

  ${DepositTableColumnStyled} {
    display: flex;
    align-items: center;

    &:nth-of-type(2) {
      font-weight: 600;
      img {
        max-width: 7.5rem;
        display: flex;
      }
    }

    @media ${media.maxPhone} {
      &:nth-of-type(2) {
        padding-left: 2.875rem;
      }
      &:nth-child(1n + 3) {
        display: none;
      }
    }
  }

  ${({ isOpened }) =>
    isOpened &&
    css`
      @media ${media.maxPhone} {
        border-bottom: 0.0625rem solid ${theme.colors.green} !important;
        & + ${DepositTableRowBodyStyled} {
          display: block;
        }

        ${DepositTableIconStyled} {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    `};
`

const DepositTableRowStyled = styled.div<WithTheme>`
  display: flex;
  flex-direction: column;

  &:not(:last-of-type) {
    ${DepositTableRowHeadStyled} {
      border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.gray5_20};
    }
  }
`

const DepositTableSubRowStyled = styled.div<WithTheme>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #efeeee;
  padding: 0.875rem 1.375rem;
  &:not(:last-of-type) {
    border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.gray5_20};
  }
`

const DepositTableSubRowColumnStyled = styled.div<WithTheme>`
  &:first-of-type {
    font-size: 0.9375rem;
    text-transform: uppercase;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    margin-bottom: 0.25rem;
  }
  &:last-of-type {
    font-size: 0.75rem;
  }
`

const DepositTableBadgeStyled = styled.div`
  margin-left: 1.375rem;
`

const DepositTableLegendStyled = styled.ul`
  margin-top: 3.75rem;
`

const DepositTableLegendItemStyled = styled.li`
  opacity: 0.5;
  font-size: 0.625rem;

  @media ${media.tablet} {
    font-size: 0.875rem;
  }
`

export {
  DepositTableContainerStyled,
  DepositTableStyled,
  DepositTableHeadStyled,
  DepositTableRowStyled,
  DepositTableRowHeadStyled,
  DepositTableRowBodyStyled,
  DepositTableColumnStyled,
  DepositTableIconStyled,
  DepositTableSubRowStyled,
  DepositTableSubRowColumnStyled,
  DepositTableBadgeStyled,
  DepositTableLegendStyled,
  DepositTableLegendItemStyled
}
